import { ColumnFilter } from '../Common/ColumnFilter';

export const COLUMNS = [
	{
		Header: 'Date',
		Footer: 'Date',
		accessor: 'debit_note_date',
		Filter: ColumnFilter,
	},
	{
		Header: 'Debit Note No.',
		Footer: 'Debit Note No.',
		accessor: 'debit_note_no',
		Filter: ColumnFilter,
	},
	{
		Header: 'Supplier',
		Footer: 'Supplier',
		accessor: 'supplier_name',
		Filter: ColumnFilter,
	},
	{
		Header: 'Subtotal',
		Footer: 'Subtotal',
		accessor: 'sub_total',
		Filter: ColumnFilter,
	},
	{
		Header: 'GST',
		Footer: 'GST',
		accessor: 'gst_amount',
		Filter: ColumnFilter,
	},
	{
		Header: 'Grand Total',
		Footer: 'Grand Total',
		accessor: 'total_amount',
		Filter: ColumnFilter,
	},
	{
		Header: 'Narration',
		Footer: 'Narration',
		accessor: 'narration',
		Filter: ColumnFilter,
	},
];

export const GROUPED_COLUMNS = [];
